import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/chunk-inspector/search/ChunkInspectorSearch.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/chunkinspector/searchquery/v1/chunkretrievaljobs`;
	}
	startJob(e) {
		return this.api.post(n.baseUrl, e);
	}
	getJobStatus(e) {
		return this.api.get(`${n.baseUrl}/${e}/status`);
	}
	getChunks(e) {
		return this.api.get(`${n.baseUrl}/${e}/result`);
	}
};
export { n as ChunkInspectorSearchResource };

//# sourceMappingURL=ChunkInspectorSearch.js.map